import { z } from "zod";

const UserRoleSchema = z.enum(["admin", "agent", "member"]);

export default UserRoleSchema;
